$(function(){
	/**
	 * 全てのメニューを見るボタン
	 */
	$('.js-show_all').click(function(){
		$(this).parents('.p-list-detail').find('.js-list li').slideDown()
		$(this).parents('.p-list-detail__btn').slideUp()
		return false;
	})

	/**
	 * チェックボックスにチェックが入っていればポップアップ表示
	 */
	$('.js-form input[type="checkbox"]').change(function(){
		$('.js-popup').stop().fadeOut();
		$('.js-form input[type="checkbox"]:checked').each(function () {
			$('.js-popup').stop().fadeIn();
		})
	})

	/**
	 * ポップアップのボタンを押したら
	 * リンク先をformの遷移先に設定し、ページ移動
	 */
	$('.js-submit a').click(function(){
		var link = $(this).attr('href');
		$('.js-form').attr('action',link);
		$('.js-form').submit();
		return false;
	})

})